import { storeToRefs } from 'pinia';
import { cartSidebarStore } from '~/stores/cartSidebar';

export default function () {

  const store = cartSidebarStore();
  const { isCartSidebarOpen } = storeToRefs(store);

  return {
    ...store,
    isCartSidebarOpen,
  };

}